// LayoutNodePresentation.js

export const PAGE_NODE_PRESENTATION = Object.freeze({
	FEED: 'FEED',
	GALLERY: 'GALLERY',
	LIST: 'LIST',
});

export function normalizePageNodePresentation(value) {
	const normalized = String(value || '').trim().toUpperCase();

	if (normalized === PAGE_NODE_PRESENTATION.FEED) return PAGE_NODE_PRESENTATION.FEED;
	if (normalized === PAGE_NODE_PRESENTATION.GALLERY) return PAGE_NODE_PRESENTATION.GALLERY;
	return PAGE_NODE_PRESENTATION.LIST;
}

export function getPageNodePresentationLabel(value) {
	const normalized = normalizePageNodePresentation(value);

	if (normalized === PAGE_NODE_PRESENTATION.FEED) return 'Feed';
	if (normalized === PAGE_NODE_PRESENTATION.GALLERY) return 'Gallery';
	return 'List';
}